// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.externalplace_GeoGrandContainer__gTmS\\+ {
  display: flex;
  justify-content: end;
}

.externalplace_GeoItem__PsYIZ {
  padding: 10px;
  border-bottom: 1px solid gainsboro;
  margin: 0px;
  background-color: white;
  text-transform: capitalize;
}

.externalplace_GeoItem__PsYIZ:hover {
  background-color: whitesmoke;
}

.externalplace_gSection__boSsp {
  background-color: #1c243b;
  margin: 5px;
  position: relative;
  border-radius: 5px;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}

.externalplace_gClosebtn__9Ns88 {
  position: relative;
  right: 20px;
  z-index: 2;
  margin: 3px;
}

.externalplace_gClosebtn1__tnGQ6 {
  position: absolute;
  right: 80px;
}

.externalplace_gClosebtn2__L0YgO {
  position: absolute;
  right: 67px;
}

.externalplace_gClosebtnJust__7oAbX {
  justify-content: end;
  padding: 5px 13px;
}

.externalplace_gImg__I4WAk {
  padding: 2px;
}

.externalplace_searchGallery__tPiYf {
  background-color: #ffffff !important;
}

.externalplace_GsearchBtn__Z1fSh {
  position: absolute;
  top: 0px;
  margin: 3px;
  right: 0px;
}

.externalplace_ResultNotFound__mPEWU {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}

.externalplace_ImgCon__m4OJ5 {
  padding: 10px;
  overflow: auto;
  margin-top: 10px;
  height: 70vh;
}

.externalplace_ImgGSpinner__gJOSI {
  display: flex;
  height: 65vh;
  justify-content: center;
  align-items: center;
}

.externalplace_paginationBox__z3bzC {
  display: flex;
  justify-content: space-around;
  padding: 10px;
  margin-top: 30px;
}

.externalplace_LeftSec__bkfvm {
  transition: 0.3s ease;
}

.externalplace_GPCloseContainer__Za9OD {
  position: absolute;
  transition: 0.4s ease;
  right: -100vw;
  z-index: 2;
}

.externalplace_GPOpenContainer__T4w-u {
  right: 0%;
  position: relative;
  transition: 0.4s ease;
  z-index: 2;
}`, "",{"version":3,"sources":["webpack://./src/styles/ItemsStyle/externalplace.module.scss","webpack://./src/styles/ItemsStyle/galleryplace.module.scss"],"names":[],"mappings":"AACA;EACI,aAAA;EACA,oBAAA;AAAJ;;AAaA;EACI,aAAA;EACA,kCAAA;EACA,WAAA;EACA,uBAAA;EACA,0BAAA;AAVJ;;AAYA;EACI,4BAAA;AATJ;;ACTA;EACE,yBAAA;EAEA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,2BAAA;EACA,4BAAA;ADWF;;ACTA;EACE,kBAAA;EACA,WAAA;EACA,UAAA;EACA,WAAA;ADYF;;ACVA;EACE,kBAAA;EACA,WAAA;ADaF;;ACXA;EACE,kBAAA;EACA,WAAA;ADcF;;ACZA;EACE,oBAAA;EACA,iBAAA;ADeF;;ACbA;EACE,YAAA;ADgBF;;ACdA;EAGE,oCAAA;ADeF;;ACbA;EACE,kBAAA;EACA,QAAA;EACA,WAAA;EACA,UAAA;ADgBF;;ACdA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;ADiBF;;ACfA;EACE,aAAA;EACA,cAAA;EACA,gBAAA;EACA,YAAA;ADkBF;;AChBA;EACE,aAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;ADmBF;;ACjBA;EACE,aAAA;EACA,6BAAA;EACA,aAAA;EACA,gBAAA;ADoBF;;AClBA;EACI,qBAAA;ADqBJ;;ACnBA;EACI,kBAAA;EACA,qBAAA;EACA,aAAA;EACA,UAAA;ADsBJ;;ACnBA;EACI,SAAA;EACA,kBAAA;EACA,qBAAA;EACA,UAAA;ADsBJ","sourcesContent":["\n.GeoGrandContainer{\n    display: flex;\n    justify-content: end;\n}\n.GeoContainer {\n    // right: 0;\n    // background-color: white;\n    // max-height: 300px;\n    // overflow: auto;\n    // border: 1px solid gainsboro;\n    // border-radius: 5px;\n    // box-shadow: 0 0 3px #ccc;\n    // margin-bottom: 5px;\n}\n\n.GeoItem {\n    padding: 10px;\n    border-bottom: 1px solid gainsboro;\n    margin: 0px;\n    background-color: white;\n    text-transform: capitalize;\n}\n.GeoItem:hover{\n    background-color: whitesmoke;\n}\n\n@import '../ItemsStyle//galleryplace.module.scss'",".gClose {\n \n}\n.gOpen {\n \n}\n.gSection {\n  background-color: #1c243b;\n  // min-height: 100vh;\n  margin: 5px;\n  position: relative;\n  border-radius: 5px;\n  border-top-left-radius: 8px;\n  border-top-right-radius: 8px;\n}\n.gClosebtn {\n  position: relative;\n  right: 20px;\n  z-index: 2;\n  margin: 3px;\n}\n.gClosebtn1 {\n  position: absolute;\n  right: 80px;\n}\n.gClosebtn2 {\n  position: absolute;\n  right: 67px;\n}\n.gClosebtnJust {\n  justify-content: end;\n  padding: 5px 13px;\n}\n.gImg {\n  padding: 2px;\n}\n.searchGallery {\n  // top: 0px;\n  // position: absolute;\n  background-color: #ffffff !important;\n}\n.GsearchBtn {\n  position: absolute;\n  top: 0px;\n  margin: 3px;\n  right: 0px;\n}\n.ResultNotFound{\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100vh;\n}\n.ImgCon {\n  padding: 10px;\n  overflow: auto;\n  margin-top: 10px;\n  height: 70vh;\n}\n.ImgGSpinner{\n  display: flex;\n  height: 65vh;\n  justify-content: center;\n  align-items: center;\n}\n.paginationBox{\n  display: flex;\n  justify-content: space-around;\n  padding: 10px;\n  margin-top: 30px;\n}\n.LeftSec{\n    transition: 0.3s ease;\n}\n.GPCloseContainer{\n    position: absolute;\n    transition: 0.4s ease;\n    right: -100vw;\n    z-index: 2;\n}\n\n.GPOpenContainer{\n    right: 0%;\n    position: relative;\n    transition: 0.4s ease;\n    z-index: 2;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"GeoGrandContainer": `externalplace_GeoGrandContainer__gTmS+`,
	"GeoItem": `externalplace_GeoItem__PsYIZ`,
	"gSection": `externalplace_gSection__boSsp`,
	"gClosebtn": `externalplace_gClosebtn__9Ns88`,
	"gClosebtn1": `externalplace_gClosebtn1__tnGQ6`,
	"gClosebtn2": `externalplace_gClosebtn2__L0YgO`,
	"gClosebtnJust": `externalplace_gClosebtnJust__7oAbX`,
	"gImg": `externalplace_gImg__I4WAk`,
	"searchGallery": `externalplace_searchGallery__tPiYf`,
	"GsearchBtn": `externalplace_GsearchBtn__Z1fSh`,
	"ResultNotFound": `externalplace_ResultNotFound__mPEWU`,
	"ImgCon": `externalplace_ImgCon__m4OJ5`,
	"ImgGSpinner": `externalplace_ImgGSpinner__gJOSI`,
	"paginationBox": `externalplace_paginationBox__z3bzC`,
	"LeftSec": `externalplace_LeftSec__bkfvm`,
	"GPCloseContainer": `externalplace_GPCloseContainer__Za9OD`,
	"GPOpenContainer": `externalplace_GPOpenContainer__T4w-u`
};
export default ___CSS_LOADER_EXPORT___;
